export default __webpack_public_path__ + "static/media/caen17.1c9011dc.jpg";